import { z } from "zod";
import { CdtCategoryStoreAssignmentSchema } from "@CommonApi/cdt/categories/_categoryId_/stores";

export const RouteCdtCategories_categoryId_Stores_storeId_Tree =
  "/cdt/categories/:categoryId/stores/:storeId/tree";

export const ParamsCdtCategoryStoreTreeSchema = z.object({
  categoryId: z.coerce.number().int().positive(),
  storeId: z.coerce.number().int().positive(),
});

export const PutCdtCategoryStoreTreeBodySchema = z.object({
  treeId: z.number().int().positive(),
});

export const ResponsePutCdtCategoryStoreTreeSchema = CdtCategoryStoreAssignmentSchema;

export type ParamsCdtCategoryStoreTree = z.infer<typeof ParamsCdtCategoryStoreTreeSchema>;
export type PutCdtCategoryStoreTreeBody = z.infer<typeof PutCdtCategoryStoreTreeBodySchema>;
export type ResponsePutCdtCategoryStoreTree = z.infer<
  typeof ResponsePutCdtCategoryStoreTreeSchema
>;
